import { Component } from '@angular/core';
import { AppService, Foo } from './app.service'
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import { Router } from '@angular/router';

import { environment } from '../environments/environment';

@Component({
    selector: 'foo-details',
    providers: [AppService],
    styleUrls: ['./foo.component.css'],
    template: `
    <div class="status-container">
        <div class="status-card">
            
            <!-- Successful Completion -->
            <div *ngIf="complete" class="success-section">
                <div class="status-icon success-icon">✓</div>
                <h1 class="status-title">Identification successfully completed!</h1>
                <p class="status-message">You can close this window now.</p>
                
                <div class="status-details">
                    <div class="detail-item">
                        <span class="detail-label">Status:</span>
                        <span class="detail-value success">{{foo?.result?.status}}</span>
                    </div>
                    <div class="detail-item" *ngIf="foo?.result?.transaction_id">
                        <span class="detail-label">Transaction ID:</span>
                        <span class="detail-value">{{foo.result.transaction_id}}</span>
                    </div>
                </div>
            </div>

            <!-- Pending Manual Review -->
            <div *ngIf="pending && !complete" class="pending-section">
                <div class="status-icon pending-icon">📄</div>
                <h1 class="status-title">Your data is currently being checked manually!</h1>
                <p class="status-message">We will inform you of the result by SMS when we have finished.</p>
                
                <button class="action-btn primary" (click)="refreshPage()">
                    <span class="btn-icon">🔄</span>
                    Refresh
                </button>
            </div>

            

            <!-- Failed Verification -->
            <div *ngIf="foo?.result?.status === 'FAILED' || foo?.result?.status === 'COMPLETED_FRAUD'" class="failed-section">
                <div class="status-icon error-icon">📄</div>
                <h1 class="status-title">Identification failed!</h1>
                <p class="status-message">Unfortunately, the identification process could not be completed successfully. Please restart the process.</p>
                
                <button class="action-btn primary" (click)="ngOnInit()">
                    Restart Identification
                </button>
            </div>

            <!-- System Error -->
            <div *ngIf="msg && msg.includes('Error')" class="system-error-section">
                <div class="status-icon error-icon">⚠️</div>
                <h1 class="status-title">System Error</h1>
                <p class="status-message">There was a technical issue with the verification system.</p>
                
                <div class="error-details">
                    <p>{{msg}}</p>
                </div>

                <button class="action-btn primary" (click)="ngOnInit()">
                    <span class="btn-icon">🔄</span>
                    Retry Connection
                </button>
            </div>

            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>`
})

export class FooComponent {
    public foo; // new Foo(1, 'sample foo');
    public url = "";
    public msg = "";
    public me;
    public isPaymentsEnabled;
    // private foosUrl = '/api/foos/';
    private meUrl = '/api/user/me';

    typeSelected: string;

    currentWallet;
    complete;
    pending;

    constructor(private _router: Router, private _service: AppService, private spinnerService: NgxSpinnerService) {
        this.typeSelected = 'ball-fussion';
    }

    // getStatus(id) {
    //     // http://localhost:8088/api/idcheck/status/
    //     this._service.getResource("/api/idcheck/status/" + id)
    //         .subscribe(
    //             data => {
    //                 console.log(data);
    //                 this.msg = 'Status: ' + data.result['status'];
    //                 this.pending = data.result['status'] === 'PENDING_MANUAL_REVIEW'

    //                 if (data.result && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
    //                     this.complete = true;
    //                 } else {
    //                     this.complete = false;
    //                     if(!this.pending)this.getNfcTransactionId();
    //                 }

    //                 //data['result'] = {}
    //                 //data['result].status = result.status = data['status'];
    //                 //const result = JSON.stringify(data);
    //                 // console.log(data);

    //             },
    //             error => this.msg = 'Error getting Status: ' + error.errorMessage);
    // }

    ngOnInit() {
        this.spinnerService.show()

        this._service.checkCredentials();
        // this.getMe();

        this._service.getResource('/api/idcheck/status')
            .subscribe(
                data => {

                    this.foo = data;
                    const nfc = data &&
                        data.result &&
                        data.result['documentVerification'] &&
                        data.result['documentVerification'].documents &&
                        data.result['documentVerification'].documents[0] &&
                        data.result['documentVerification'].documents[0].nfc;

                    if (data && data.result) {
                        this.msg = 'Status: ' + data.result['status'];
                        this.pending = data.result['status'] === 'PENDING_MANUAL_REVIEW'

                        // if (data.result && nfc && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
                        if (data.result && data.result['status'] === 'COMPLETED' || data.result['status'] === 'COMPLETED_FRAUD') {
                            this.complete = true;
                        } else {
                            this.complete = false;
                            if (!this.pending) this.getNfcTransactionId();
                        }
                    } else {
                        this.complete = false;
                        this.getNfcTransactionId();
                    }
                    this.spinnerService.hide();
                },
                error => {
                    console.log(error);
                    this.spinnerService.hide();
                });


    }



    getMe() {
        this._service.getResource(this.meUrl)
            .subscribe(
                data => {
                    this.me = data;
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    this.isPaymentsEnabled = _.get(data, 'bank_user_id') ? true : false;
                    if (this.isPaymentsEnabled) this.getWallet();
                    console.log("me: ", data)
                },
                error => this.msg = 'Error getting current user: ' + error.errorMessage);
    }

    getWallet() {
        this._service.getResource(`/api/user/wallets/${_.get(this.me, 'bank_user_id')}`)
            .subscribe(
                data => {
                    if (data[0]) {
                        this.currentWallet = data[0];
                    } else {
                        alert("Your permission for Payments is under review!")
                    }
                    //data['result'] = {}
                    //data['result].status = result.status = data['status'];
                    //const result = JSON.stringify(data);
                    console.log(data);

                },
                error => this.msg = 'Error getting wallet: ' + error.errorMessage);
    }

    getTransactionId() {
        console.log("getTransactionId")
        this.spinnerService.show();
        this._service.getTransactionId()
            .subscribe(
                data => {
                    // console.log(data['data']['transactionCode'], JSON.stringify(data))
                    location.href = `${environment.pxlApiServer}/?tc=${data}&oi=${environment.pxlOiUrl}`
                },
                error => this.msg = 'Error getting pxl transaction id: ' + error.errorMessage);

    }

    getNfcTransactionId() {
        console.log("getNfcTransactionId")
        this.spinnerService.show();
        this._service.getNfcTransactionId()
            .subscribe(
                data => {
                    // console.log(data['data']['transactionCode'], JSON.stringify(data))
                    location.href = `${environment.pxlApiServer}/?tc=${data}&oi=${environment.pxlOiUrl}`
                },
                error => this.msg = 'Error getting pxl transaction id: ' + error.errorMessage);

    }

    wallet() {
        this._router.navigateByUrl('/wallet');
    }

    topup() {
        this._router.navigateByUrl('/topup');
    }

    questionaire() {
        console.log("questionaire");
        this._router.navigateByUrl('/questionaire');
        /*
        this.spinnerService.show();
        this._service.enablePayments("")
            .subscribe(
                data => {
                     console.log(JSON.stringify(data))

                },
                error => this.msg = 'Error');
        */

    }

    calculate_age(d) {
        const dob = new Date(d);
        var diff_ms = Date.now() - dob.getTime();
        var age_dt = new Date(diff_ms);

        return Math.abs(age_dt.getUTCFullYear() - 1970);
    }

    expired(d) {
        let quoteExpiry = new Date(d).getTime();
        let now = new Date()
        return (now.getTime() > quoteExpiry) ? true : false;
    }
    scan() {
        this._router.navigate(['/scan', ""]);
    }

    refreshPage() {
        location.reload();
    }
}
